export default __webpack_public_path__ + "static/media/statistics1.9201533a.svg";